// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_o1-0";